import React, { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { Helmet } from "react-helmet";
import { db } from "../firebase";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import emailjs from "@emailjs/browser";

const initialForm = {
  nom: "",
  telephone: "",
  email: "",
  marque: "",
  modele: "",
  immatriculation: "",
  service: "",
  dateSouhaitee: "",
  message: "",
};

export default function MaintenanceRendezvous() {
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  try {
    const docRef = await addDoc(collection(db, "maintenance_appointments"), {
      ...formData,
      statut: "en attente",
      createdAt: serverTimestamp(),
    });

    await emailjs.send(
      "service_f6qpmie",
      "template_y8h0myv",
      {
        nom: formData.nom,
        telephone: formData.telephone,
        email: formData.email,
        vehicule: `${formData.marque} ${formData.modele}`,
        dateDebut: formData.dateSouhaitee,
        dateFin: formData.dateSouhaitee,
        lien: `https://thebridgeofworld.com/admin/maintenance`,
        message: `
🛠️ NOUVELLE DEMANDE DE MAINTENANCE

👤 Nom : ${formData.nom}
📞 Téléphone : ${formData.telephone}
✉️ Email : ${formData.email || "Non renseigné"}

🚗 Véhicule : ${formData.marque} ${formData.modele}
🪪 Immatriculation : ${formData.immatriculation || "Non renseignée"}
🔧 Service demandé : ${formData.service}
📅 Date souhaitée : ${
          formData.dateSouhaitee
            ? new Date(formData.dateSouhaitee).toLocaleDateString("fr-FR")
            : "Non renseignée"
        }

📝 Message :
${formData.message || "Aucun message complémentaire"}

🆔 ID demande : ${docRef.id}
🔗 Voir les demandes : https://thebridgeofworld.com/admin/maintenance
💬 WhatsApp : https://wa.me/${formData.telephone.replace(/\D/g, "")}
✉️ Email : ${formData.email ? `mailto:${formData.email}` : "Non renseigné"}
        `.trim(),
      },
      "ue1japEYODKjLR_iZ"
    );

    setSuccess(true);
    setFormData(initialForm);
  } catch (err) {
    console.error(err);
    setError("Une erreur est survenue lors de l’envoi du rendez-vous.");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <Helmet>
        <title>Prendre rendez-vous maintenance | THE BRIDGE</title>
        <meta
          name="description"
          content="Prenez rendez-vous pour l’entretien et la maintenance de votre véhicule avec THE BRIDGE."
        />
      </Helmet>

      <MenuNav />
      <MobileMenu />

      <div className="container py-5">
        <div className="text-center mb-5">
          <span className="badge bg-primary px-3 py-2 mb-3">
            Maintenance automobile
          </span>
          <h1 className="fw-bold">Prendre rendez-vous pour la maintenance</h1>
          <p className="text-muted">
            Réservez un créneau pour l’entretien, le diagnostic ou la réparation de votre véhicule.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-lg-7">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                {success && (
                  <div className="alert alert-success">
                    Votre demande de rendez-vous a été envoyée avec succès.
                  </div>
                )}

                {error && (
                  <div className="alert alert-danger">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Nom complet</label>
                      <input
                        type="text"
                        className="form-control"
                        name="nom"
                        value={formData.nom}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Téléphone</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Date souhaitée</label>
                      <input
                        type="date"
                        className="form-control"
                        name="dateSouhaitee"
                        value={formData.dateSouhaitee}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Marque</label>
                      <input
                        type="text"
                        className="form-control"
                        name="marque"
                        value={formData.marque}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Modèle</label>
                      <input
                        type="text"
                        className="form-control"
                        name="modele"
                        value={formData.modele}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Immatriculation</label>
                      <input
                        type="text"
                        className="form-control"
                        name="immatriculation"
                        value={formData.immatriculation}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Type de service</label>
                      <select
                        className="form-select"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Choisir un service</option>
                        <option value="Entretien">Entretien</option>
                        <option value="Vidange">Vidange</option>
                        <option value="Diagnostic">Diagnostic</option>
                        <option value="Freinage">Freinage</option>
                        <option value="Moteur">Moteur</option>
                        <option value="Climatisation">Climatisation</option>
                        <option value="Électricité">Électricité</option>
                        <option value="Suspension">Suspension</option>
                        <option value="Autre">Autre</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Message</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Décrivez le problème ou le besoin..."
                      ></textarea>
                    </div>

                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Envoi en cours..." : "Envoyer la demande de rendez-vous"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <h4 className="fw-bold mb-3">Pourquoi prendre rendez-vous avec THE BRIDGE ?</h4>

                <ul className="list-unstyled">
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Entretien et maintenance avec suivi professionnel
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Diagnostic rapide et accompagnement personnalisé
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Accès à des pièces adaptées à votre véhicule
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Contact direct via WhatsApp si besoin
                  </li>
                </ul>

                <a
                  href="https://wa.me/22878815494"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success w-100 mt-3"
                >
                  Contacter sur WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
